var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExport = function SvgExport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M113 64v27c0 9.389-7.611 17-17 17H32c-9.389 0-17-7.611-17-17V64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m84.213 37.586-17.799-17.8a2 2 0 0 0-2.828 0l-17.8 17.8A2 2 0 0 0 47.202 41H82.8a2 2 0 0 0 1.414-3.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M64.5 78.5 65 35"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExport);
export default ForwardRef;